import { punchoutCookies } from "@/core/utilities/punchout/punchoutCookies";
import type { RouteRecordRaw } from "vue-router";

const Checkout = () => import("@/pages/checkout/index.vue");
const ShippingAddress = () => import("@/shared/checkout/components/steps/shipping-address.vue");
const ShippingMethod = () => import("@/shared/checkout/components/steps/shipping-method.vue");
const ExportItems = () => import("@/shared/checkout/components/steps/export-items.vue");
const ResellerPreference = () => import("@/shared/checkout/components/steps/reseller-preference.vue");
const Payment = () => import("@/shared/checkout/components/steps/payment.vue");
const Completed = () => import("@/pages/checkout/completed.vue");

export const checkoutRoutes: RouteRecordRaw[] = [
  {
    path: "/checkout/confirmation",
    name: "CheckoutCompleted",
    component: Completed,
  },
  {
    path: "/checkout",
    name: "Checkout",
    component: Checkout,
    children: [
      {
        path: "shippingAddress",
        name: "CheckoutShippingAddress",
        component: ShippingAddress,
      },
      {
        path: "shippingMethod",
        name: "CheckoutShippingMethod",
        component: ShippingMethod,
      },
      {
        path: "payment",
        name: "CheckoutPayment",
        component: Payment,
      },
      {
        path: "exportItems",
        name: "CheckoutExportItems",
        component: ExportItems,
      },
      {
        path: "resellerPreference",
        name: "CheckoutResellerPreference",
        component: ResellerPreference,
      },
    ],
    meta: { layout: "Secure" },
    beforeEnter(to, from, next) {
      if (punchoutCookies.value) {
        next({ path: "/404" }); // Redirect to not found page
      }
      if (from.name === "Cart") {
        next();
      } else if (from.name === "Quotes" || from.name === "QuoteDetails") {
        next();
      } else {
        next({ name: "Cart", replace: true });
      }
    },
  },
  {
    path: "/quote",
    name: "Quote",
    component: Checkout,
    children: [
      {
        path: "shippingAddress",
        name: "QuoteShippingAddress",
        component: ShippingAddress,
      },
      {
        path: "shippingMethod",
        name: "QuoteShippingMethod",
        component: ShippingMethod,
      },
      {
        path: "payment",
        name: "QuotePayment",
        component: Payment,
      },
      {
        path: "exportItems",
        name: "QuoteExportItems",
        component: ExportItems,
      },
      {
        path: "resellerPreference",
        name: "QuoteResellerPreference",
        component: ResellerPreference,
      },
    ],
    meta: { layout: "Secure" },
    beforeEnter(to, from, next) {
      if (punchoutCookies.value) {
        next({ path: "/404" }); // Redirect to not found page
      }
      if (from.name === "Cart") {
        next();
      } else if (from.name === "CheckoutPaymentResult" && to.name === "CheckoutPayment") {
        next();
      } else {
        next({ name: "Cart", replace: true });
      }
    },
  },
  {
    path: "/acceptQuote",
    name: "AcceptQuote",
    component: Checkout,
    children: [
      {
        path: "shippingAddress",
        name: "AcceptQuoteShippingAddress",
        component: ShippingAddress,
      },
      {
        path: "shippingMethod",
        name: "AcceptQuoteShippingMethod",
        component: ShippingMethod,
      },
      {
        path: "payment",
        name: "AcceptQuotePayment",
        component: Payment,
      },
      {
        path: "exportItems",
        name: "AcceptQuoteExportItems",
        component: ExportItems,
      },
      {
        path: "resellerPreference",
        name: "AcceptQuoteResellerPreference",
        component: ResellerPreference,
      },
    ],
    meta: { layout: "Secure" },
    // beforeEnter(to, from, next) {
    //   if (from.name === "Cart") {
    //     next();
    //   } else if (from.name === "CheckoutPaymentResult" && to.name === "CheckoutPayment") {
    //     next();
    //   } else {
    //     next({ name: "Cart", replace: true });
    //   }
    // },
  },
];
